// eslint-disable-next-line import/prefer-default-export
export const API_URL_1 = process.env.REACT_APP_BASE_URL;
